import { apiCallback } from 'api';
import { trackPersonalisationHeader } from 'api/utils/personalisation-header';

const definition = {
  service: 'content',
  endpoint: 'cms/publish/productcontent/search/${customerId}',
  query: {
    clientType: 'WEB_APP',
  },
  headers: {
    'wtr-uuid': '${uuid}',
  },
  verbs: ['post'],
  defaultVersion: 2,
};

export default {
  post: apiCallback(definition, 'post', trackPersonalisationHeader),
};
